import Vue from 'vue';

import help_chart from '@/helpers/chart';
import forEach from 'lodash/forEach';

import * as html2canvas from 'html2canvas';

export default function newVueChart(){
	return {
		template: '<div></div>',
		computed: {
			presentation(){
				return this.$store.getters.presentation;
			},
			saveing(){
				return this.$store.getters.saveing;
			},
			loading(){
				return this.$store.getters.loading;
			},
			areas(){
				return this.$store.getters.getChartFields(this.data.id, true);
			},
		},
		data: function(){
			return {
				hoverrect: false,
				rendering: false,
				content: null, //für den wysiwyg
				editing: false,
				resizehash: false
			};
		},
		props: {
			preview: {
				type: Boolean,
				default: false
			},
			editable: {
				type: Boolean,
				default: true
			},
			active: {
				type: Number,
				default: 0
			},
			data: {
				type: Object,
				default: function(){
					return {};
				}
			}
		},
		created(){
			if(!this.preview){
				if(app && app.evn && app.evn.subscribe){
					app.evn.subscribe('resize', this.resize);
				} else {
					window.addEventListener('resize', this.resize, true);
				}
			}
			this.resize();
		},
		destroyed(){
			if(!this.preview){
				if(app && app.evn && app.evn.unsubscribe){
					app.evn.unsubscribe('resize', this.resize);
				} else {
					window.removeEventListener('resize', this.resize);
				}
			}
		},
		mounted(){
			this.renderChart();
			this.resize();
		},
		methods: {
			onMove: help_chart.onMove,
			editableEvent(event){
				var target = event.target;
				switch(event.type){
					case 'click':
						break;
					case 'mouseover':
						if(!this.hoverrect) {
							if(target.nodeName != 'g') {
								target = target.parentNode;
							}
							if(target.nodeName != 'g') {
								target = target.parentNode;
							}


							var bbox = target.getBBox(),
								rect = document.createElementNS("http://www.w3.org/2000/svg",'rect');

							rect.setAttribute('x',			bbox.x);
							rect.setAttribute('y',			bbox.y);
							rect.setAttribute('height',		bbox.height);
							rect.setAttribute('width',		bbox.width);

							rect.setAttribute('stroke', 		'#a3248f');
							rect.setAttribute('stroke-width', 	'4');
							rect.setAttribute('fill-rule', 		'evenodd');

							target.appendChild(rect);
	    					this.hoverrect = rect;
	    				}
						break;
					case 'mouseleave':
						if(this.hoverrect) {
							this.hoverrect.remove();
							this.hoverrect = false;
						}
						break;
				}
			},
			renderChart(){
				const self = this;
				if(this.$store.getters['features/livepreview']){
					return;
				}

				if(!this.$el){
					if(self.$store.getters.devmode) console.debug('cant render chart without element');
					return;
				}
				if(!this.data.id) {
					return;
				}
				if(this.rendering) {
					return;
				}

				if(typeof window.running === 'undefined') window.running = false;
				if(window.running) {
					return;
				}

				const chartid = this.data.id;
				let chart = this.$store.getters.getChartById(chartid);
				if(!chart) return;
				if(typeof chart.changed === 'undefined') chart.changed = false;


				if(!chart.image || chart.changed){
					if(window.innerHeight < 900 || window.innerWidth < 1907){
						if(self.$store.getters.devmode) console.debug('cant start `renderChart` because your windows is to small');
						return;
					}
					if(self.$store.getters.devmode) console.debug('start renderChart');
					window.running = true;
					this.rendering = true;

					const el = this.$el.querySelector('section.st-chart');

				    if(el){
						const rect 	= el.getBoundingClientRect();

						var width 	= rect.width,
							height 	= rect.height,
							scale;

						if(scale = el.getAttribute('data-scale')){
							width = react.width * scale;
							height = react.height * scale;
						}

	  					html2canvas(el, {
	  						useCORS: true,
						    allowTaint: true,
						    letterRendering: true,
						    logging: false,
	  						background: '#fff',
	  						width: width,
	  						height: height
	  					}).then((canvas) => {
		  					var extra_canvas = document.createElement("canvas");
			                extra_canvas.setAttribute('width',300);
			                extra_canvas.setAttribute('height',180);
			                var ctx = extra_canvas.getContext('2d');
			                ctx.drawImage(canvas,0,0,canvas.width, canvas.height,0,0,300,180);
			                var base = extra_canvas.toDataURL("image/png");

			                // var base = canvas.toDataURL("image/png");
			                if(self.$store.getters.devmode) console.debug('finsihed rendering')

	  						self.$store.commit('UPDATE_CHART', {'id': chart.id, newImage: true, 'image': base });
		    				self.rendering = false;
		    				window.running = false;
						}).catch(err => {
							self.rendering = false;
		    				window.running = false;
							console.error('html2canvas', err);
						});
	     			} else {
	     				console.error('el nicht gefunden, section.st-chart');
	     			}
				}
			},

			resize(){
				if(this.$el){
					const main = this.$el.parentNode || document.querySelector('.ui-editor__main'),
						  resizehash = this.resizehash;
					const parentRect = main.getBoundingClientRect(),
						  stChartEl = this.$el.querySelector('.st-chart');

					console.log(this.$el.parentNode);


					if(stChartEl){
						let scale = Math.min( parentRect.width / (1600), (parentRect.height > window.innerHeight - 180 ? window.innerHeight - 180  : parentRect.height) / (900) );
						if(scale != resizehash){
							stChartEl.style.transform = 'scale(' + (scale > 1 ? 1 : scale) + ')';
							stChartEl.setAttribute('data-scale', scale);
							// stChartEl.style.zoom = scale;
							this.resizehash = scale;
						}
					}
				}
			},
		}
	};
}



// WEBPACK FOOTER //
// ./src/helpers/newChart.js